import * as React from 'react';
import type { QuoteStoryCard } from '@org/model';
import { formatStoryLabel } from './labels';
import { storyPosterAccent } from './stories-theme';
import { StorySeal } from './story-bits';
import type { StoryCardComponentProps } from './story-types';
import {
  pickLocalized,
  renderStoryMarkup,
  storyFirstName,
  storyLangAttr,
  storyWomanCharacteristic,
  storyWomanQuote,
  StoryCardHeading,
} from './story-utils';

/**
 * Quote card: an optional intro line, the woman's quote with its source (both
 * from her profile), and the seal she hands over at the end of the unit.
 */
export function StoryQuoteCard({ card, ctx }: StoryCardComponentProps<QuoteStoryCard>) {
  const { woman, lang, labels, theme } = ctx;
  const intro = pickLocalized(card.body, lang);
  const quote = storyWomanQuote(woman, lang);
  const characteristic = storyWomanCharacteristic(woman, lang);
  return (
    <div className="zs-pg-in" data-testid="story-card-quote">
      <StoryCardHeading card={card} lang={lang} />
      {intro.text ? (
        <p className="zs-why" lang={storyLangAttr(intro.lang)}>
          {renderStoryMarkup(intro.text)}
        </p>
      ) : null}
      {quote.text ? (
        <>
          <div
            className="zs-qt"
            lang={storyLangAttr(quote.lang)}
            style={{ fontSize: quote.text.length > 160 ? 20 : quote.text.length > 80 ? 25 : 30, color: theme.head }}
          >
            “{quote.text}”
          </div>
          <div className="zs-src">
            — {woman.name}
            {woman.quoteSource?.trim() ? `, ${woman.quoteSource.trim()}` : ''}
          </div>
        </>
      ) : null}
      {characteristic ? (
        <div className="zs-promise">
          <div className="zs-slot">
            <StorySeal symbol={woman.symbol} label={characteristic} background={storyPosterAccent(ctx.posterStyle)} size={76} />
          </div>
          <p>
            {formatStoryLabel(labels.promise, { characteristic: characteristic.toUpperCase() })}
            <i>{formatStoryLabel(labels.promiseFrom, { name: storyFirstName(woman.name) })}</i>
          </p>
        </div>
      ) : null}
    </div>
  );
}
